import React from 'react';
import PropTypes from 'prop-types';
import looppa from 'looppa';
import t from 'translations';
import { brandImage } from 'util/react/stack-images-path';
import imageAttrs from 'util/react/image-attributes';
import classnames from 'classnames';

export default function BrandsList({ brands }) {
    return (
        <div className="brands-list">
            { brands.length ? <h2 className="brands-list--title u-reset">{t('brands.title')}</h2> : null }
            <ul className="brands-list--list u-reset">
                { looppa(brands)((brand, i) => (
                    <li key={i} className={ classnames('brands-list--item', { 'brands-list--item__has-image': !!brand.image })}>
                        { brand.image ? <img className="brands-list--image" alt={brand.name} {...imageAttrs(brandImage(brand.image))} /> : null }{brand.name}
                    </li>
                ))}
            </ul>
        </div>
    );
}

BrandsList.propTypes = {
    brands: PropTypes.array.isRequired,
};

BrandsList.defaultProps = {
    brands: [],
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/brands-list/index.js